<template>  
  <v-layout class="drawer-container" column >  
    <div ref="liste" class="liste" :style="{overflow:items.length <= 24?'auto':'none'}">      
      <auto-virtual-scroll-list 
        v-if="items.length > 24" 
        v-resize="onResize" :totalHeight="height"
        :defaultHeight="20"
        :extra-items="5">            
        <debug-list-line :item="item" v-for="(item,index) in items" :key="index" />        
      </auto-virtual-scroll-list>
      <div v-else >
        <debug-list-line :item="item" v-for="(item,index) in items" :key="index" />                
      </div>
    </div>
  </v-layout>
</template>

<script lang="ts">
import Vue from 'vue'
import Component from 'vue-class-component'
import DebugListLine from '@/components/admin/debug/DebugListLine.vue'
import { DebugItem } from '../../../models/ui/DebugItem'; 

@Component({
  name: 'DebugList',
  components: {DebugListLine}
})

export default class DebugList extends Vue {  
  
  height = 100        
  
  mounted(){
    this.onResize()
  }

  onResize(){            
    //@ts-ignore
    this.height = this.$refs.liste.clientHeight       
  }
  
  get filter(){
    return this.$store.myGetters.debugFilter
  }

  get items():Array<DebugItem> {        
    return this.$store.myGetters.debugItems.filter(it => 
      (this.filter.search.length == 0 || JSON.stringify(it.data).indexOf(this.filter.search) > -1)
    ).slice().reverse()
  }
  
  
}

</script>


<style scope>  
  .header-list{
    flex: 0 0 auto;
  }
 .liste {
    flex: 1 1 auto;
    overflow: hidden;
    height: min-content;
  }  
</style>